document.addEventListener("DOMContentLoaded", function () {
  // ===== CXO SWIPER CONFIG =====
  const cxoEl = document.querySelector(".cxoSwiper");
  if (cxoEl) {
    const CXO_DESKTOP_SLIDES = 4;
    const CXO_TABLET_SLIDES = 2.5;
    const CXO_MOBILE_SLIDES = 1.2;
    const CXO_DESKTOP_SPACE = 16;
    const CXO_TABLET_SPACE = 12;
    const CXO_MOBILE_SPACE = 10;
    const CXO_AUTOPLAY_DELAY = 3500; // in ms
    new Swiper(".cxoSwiper", {
      loop: true,
      slidesPerView: CXO_DESKTOP_SLIDES,
      spaceBetween: CXO_DESKTOP_SPACE,
      pagination: {
        el: ".cxo-pagination",
        clickable: true,
      },
      autoplay: {
        delay: CXO_AUTOPLAY_DELAY,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          slidesPerView: CXO_MOBILE_SLIDES,
          spaceBetween: CXO_MOBILE_SPACE,
        },
        768: {
          slidesPerView: CXO_TABLET_SLIDES,
          spaceBetween: CXO_TABLET_SPACE,
        },
        1024: {
          slidesPerView: CXO_DESKTOP_SLIDES,
          spaceBetween: CXO_DESKTOP_SPACE,
        },
      },
    });
  }

  // ===== PODCAST SWIPER CONFIG =====
  const podcastEl = document.querySelector(".podcastSwiper");
  if (podcastEl) {
    // 1. Configure the number of slides and spacing
    const PODCAST_DESKTOP_SLIDES = 4;
    const PODCAST_TABLET_SLIDES = 2.5;
    const PODCAST_MOBILE_SLIDES = 1.2;

    const PODCAST_DESKTOP_SPACE = 16;
    const PODCAST_TABLET_SPACE = 15;
    const PODCAST_MOBILE_SPACE = 10;

    // 2. Autoplay settings
    const PODCAST_AUTOPLAY_DELAY = 5000; // in ms

    // 3. Initialize Swiper
    new Swiper(".podcastSwiper", {
      loop: true,
      slidesPerView: PODCAST_DESKTOP_SLIDES,
      spaceBetween: PODCAST_DESKTOP_SPACE,
      pagination: {
        el: ".podcast-pagination",
        clickable: true,
      },
      autoplay: {
        delay: PODCAST_AUTOPLAY_DELAY,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          slidesPerView: PODCAST_MOBILE_SLIDES,
          spaceBetween: PODCAST_MOBILE_SPACE,
        },
        768: {
          slidesPerView: PODCAST_TABLET_SLIDES,
          spaceBetween: PODCAST_TABLET_SPACE,
        },
        1024: {
          slidesPerView: PODCAST_DESKTOP_SLIDES,
          spaceBetween: PODCAST_DESKTOP_SPACE,
        },
      },
    });
  }
});
